import { render, staticRenderFns } from "./AreaManagement.vue?vue&type=template&id=0e3c52a7&scoped=true"
import script from "./AreaManagement.vue?vue&type=script&lang=js"
export * from "./AreaManagement.vue?vue&type=script&lang=js"
import style0 from "./AreaManagement.vue?vue&type=style&index=0&id=0e3c52a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3c52a7",
  null
  
)

export default component.exports